<template>
    <div class="card-video txt-letter-n-2">
        <router-link :to="{name:'Video', params:{id:video.idVideo.toString(),n:formatLink(video.nmTitulo)}}">
            <img class="img-fluid mb-2" :src="video.urlImagem" onerror="this.onerror=null; this.src='/image-not-found.jpg'" />
            <div class="d-flex justify-content-between align-items-center mb-1">
                <span class="txt-h-6 txt-size-12 txt-grey-2 mb-0 txt-letter-3">
                    {{formatDate(video.dtInclusao)}}
                </span>

                <span class="txt-h-6 txt-size-12 bg-blue-2 txt-white badge" v-if="video.dsCategoria">
                    {{video.dsCategoria}}
                </span>
                <!--<span class="txt-h-6 txt-size-12 bg-cores-1 txt-white badge" v-if="video.dsCategoria">
                {{video.dsCategoria}}
            </span>
            <span class="txt-h-6 txt-size-12 txt-letter-n-2 txt-cores-1" v-if="video.dsCategoria">
                {{video.dsCategoria}}
            </span>-->
            </div>


            <p class="txt-h-4 txt-blue-2 mb-1 reduz-texto-3">
                {{video.nmTitulo}}
            </p>
            <p class="txt-h-5 txt-grey-2 txt-w-6 mb-1 reduz-texto-3">
                {{video.dsVideo}}
            </p>
        </router-link>
    </div>
</template>

<script>
    import moment from 'moment'

    export default {
        name: 'CardVideo',
        props: {
            video: {
                type: Object,
                required: true
            },
        },
        data: function () {
            return {
               
            }
        },
        methods: {
            formatDate(date) {
                return moment(date).format('DD/MM/YYYY [às] HH:mm');
            },

            formatLink(titulo) {
                if (titulo) {
                    return titulo.toLowerCase().replace(/\s/g, '-');
                } else {
                    return "";
                }
            },

        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    

</style>

